import React, {Component} from 'react'
import Logo from '../Logo'
import Panel from '../Panel'
import {style, media, merge} from 'glamor'
import * as colors from '../../colors'
import {Arrow} from 'reline'
import Page from './Page'

export default class extends Component {

  shouldComponentUpdate(){
    return false
  }

  render(){
    return (
      <Page>
        <div
          {...style({
            marginTop: '4rem',
            marginBottom: '0rem',
            fontSize: '3rem'
          })}
          data-animate
        >
          <Logo/>
        </div>

        <div
          data-animate
          {...style({
            marginBottom: '2rem',
          })}
        >
          Conseil creation production
        </div>

        <div
          data-animate
          {...merge(
            style({
              marginBottom: '4rem',
              color: colors.lightSilver,
              fontSize: '1.5rem',
              fontWeight: '300',
            }),
            media('(min-width: 800px)',{
              marginBottom: '4rem'
            })
          )}
        >
          Si Buyideas était une agence de plus,
          <br
            {...merge(
              style({
                display: 'none'
              }),
              media('(min-width:600px)', {
                display: 'block'
              })
            )}
          />
          ça serait une agence de trop.
        </div>
        <div
          {...style({
            display: 'flex',
            justifyContent: 'flex-end',
            fontStyle: 'italic'
          })}
        >
          <Panel
            data-animate
            {...media('(min-width: 800px)',{
              width: '70%'
            })}
          >
            <p>
              Buyideas crée sur mesure des équipes d'experts de la création et de la production. Annonceurs, agences qui n'ont pas de service de création interne, tous ont déjà utilisé les services de Buyideas
            </p>
            <p>
              Souplesse, réactivité, compétitivité et créativité font le succès de cette alternative aux agences traditionnelles.
            </p>
          </Panel>
        </div>
      </Page>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/pages/IdeasToBuy.js
 **/